import Route from 'cio/routes/base';

export default class IndexRoute extends Route {
  afterModel(model) {
    let route = model.get('isSent') ? 'overview' : 'setup';
    return this.router.transitionTo(`broadcasts.newsletter.${route}`);
  }
}
